export default (vm) => {
  const btns = {}
  btns[vm.$t('log.aWeekBeforeBtn')] = [vm.moment().subtract(6, 'days'), vm.moment()]
  btns[vm.$t('log.oneMonthBeforeBtn')] = [vm.moment().subtract(1, 'months'), vm.moment()]
  btns[vm.$t('log.threeMonthsBeforeBtn')] = [vm.moment().subtract(3, 'months'), vm.moment()]
  return btns
}